import ProgressBar from "./ProgressBar";

const FALLBACK_AGE_GROUPS = [
  { label: "18 – 21", percent: 0, count: 0 },
  { label: "22 – 26", percent: 0, count: 0 },
  { label: "27 – 31", percent: 0, count: 0 },
  { label: "32 – 35", percent: 0, count: 0 },
];

const AgeDistribution = ({ ageGroups = [] }) => {
  const data = ageGroups.length > 0 ? ageGroups : FALLBACK_AGE_GROUPS;

  return (
    <div className="space-y-3">
      {data.map((item) => (
        <div key={item.label}>
          <div className="flex justify-between text-sm mb-1">
            <span>{item.label}</span>
            <span className="text-green-700 font-semibold">
              {item.percent}% ({typeof item.count === "number" ? item.count.toLocaleString() : item.count ?? 0})
            </span>
          </div>
          <ProgressBar value={item.percent} />
        </div>
      ))}
    </div>
  );
};

export default AgeDistribution;
